import React from 'react';
import { Button } from './ui/button';
import { Phone, MessageCircle } from 'lucide-react';
import { heroData } from '../utils/mockData';

const Hero = ({ onContactClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="hero-title">
              {heroData.title}
            </h1>
            <h2 className="hero-subtitle">
              {heroData.subtitle}
            </h2>
            <p className="hero-description">
              {heroData.description}
            </p>
            <div className="hero-cta-group">
              <Button 
                onClick={onContactClick}
                className="cta-primary"
                size="lg"
              >
                {heroData.ctaText}
              </Button>
              <Button 
                variant="outline"
                size="lg"
                className="cta-secondary"
                onClick={() => window.open(`https://wa.me/${heroData.phone.replace(/\+/g, '')}`, '_blank')}
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                WhatsApp
              </Button>
              <Button 
                variant="outline"
                size="lg"
                className="cta-secondary"
                onClick={() => window.location.href = `tel:${heroData.phone}`}
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
